import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export { dayjs };

export function formatDate(
  date: string | Date | null | undefined,
  format = "MM/DD/YYYY",
): string {
  if (!date) return "";
  return dayjs(date).format(format);
}

export function formatDateTime(
  date: string | Date | null | undefined,
  format = "MM/DD/YYYY h:mm A",
): string {
  if (!date) return "";
  return dayjs(date).format(format);
}

export function fromNow(date: string | Date | null | undefined): string {
  if (!date) return "";
  return dayjs(date).fromNow();
}
